module.exports = __webpack_public_path__ + "img/app_store.92760398.png";